import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withSnackbar } from 'notistack';
import { getNotifications } from 'store/selectors/notifications';
import { removeNotification } from 'store/actions/notifications';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// https://github.com/iamhosseindhv/notistack/issues/8#issuecomment-438664205
class Notifier extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayed: [],
    };
  }

  render = () => {
    const { notifications } = this.props;

    notifications.forEach(notification => {
      setTimeout(() => {
        // If notification already displayed, abort
        if (
          this.state.displayed.filter(key => key === notification.key).length >
          0
        ) {
          return;
        }

        // Display notification using Snackbar
        this.props.enqueueSnackbar(notification.message, {
          variant: notification.type,
          action: key => (
            <IconButton
              onClick={() => this.props.closeSnackbar(key)}
              color="inherit"
            >
              <CloseIcon />
            </IconButton>
          ),
        });

        // Add notification's key to the local state
        this.setState({
          displayed: [...this.state.displayed, notification.key],
        });

        // Dispatch action to remove the notification from the redux store
        this.props.removeNotification(notification.key);
      }, 300);
    });

    return null;
  };
}

const mapStateToProps = createStructuredSelector({
  notifications: getNotifications,
});
export default compose(
  connect(mapStateToProps, { removeNotification }),
  withSnackbar
)(Notifier);
